<template>
  <div id="app">
	<Modal 
          v-model="isShowAnnouncement"
           width="480"
           :closable="true"
           :mask-closable="true"
           :footer-hide="true">
            <p slot="header" style="text-align:center">
              <span style="font-size:18px;">公告</span>
            </p>
            <div class="content">
             {{params.tip}}
            </div>
            
        </Modal>
    <router-view/>
  </div>
</template>

<script>
export default {
  data() {
			return {
				isShowAnnouncement:false,
				params:""
			}
		},
		created() {},
		updated() {},
		methods:{
		showDialog()
		{
		if(sessionStorage.getItem("tipData"))
		{
			this.params = JSON.parse(sessionStorage.getItem("tipData"));
			console.log(this.params,'this.params');
			if(this.params.tip !==  '')
			{
			this.isShowAnnouncement = true;

			}
			else
			{
			this.isShowAnnouncement = false;
			}
			
		}
		},
  },
		mounted() {},
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue